import { render, staticRenderFns } from "./SublimeCharges.vue?vue&type=template&id=f5a050b8&scoped=true&"
import script from "./SublimeCharges.vue?vue&type=script&lang=ts&"
export * from "./SublimeCharges.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a050b8",
  null
  
)

export default component.exports